import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import Step1BasicInfo from '../../components/postHorse/Step1BasicInfo';
import Step2Temperament from '../../components/postHorse/Step2Temperment';
import Step3Health from '../../components/postHorse/Step3Health';
import Step4Pricing from '../../components/postHorse/Step4Pricing';
import Step5Finalize from '../../components/postHorse/Step5Finalize';
import { ReactSortable } from 'react-sortablejs';

export default function PostHorse() {
  const [currentStep, setCurrentStep] = useState(1);
  const [dropdowns, setDropdowns] = useState(null); // initially null
  const [formData, setFormData] = useState({}); // use empty object to start

  useEffect(() => {
    async function fetchDropdowns() {
      try {
        const [dropdownRes, breedRes] = await Promise.all([
          api.get('/dropdowns/horseAttributes'),
          api.get('/breeds')
        ]);

        console.log('✅ Dropdowns:', dropdownRes.data);
        console.log('✅ Breeds:', breedRes.data);

        setDropdowns({
          ...dropdownRes.data,        // sex, color, etc.
          breeds: breedRes.data       // override with breed objects
        });
      } catch (err) {
        console.error('❌ Failed to fetch dropdowns:', err);
      }
    }

    fetchDropdowns();
  }, []);

  const goNext = () => setCurrentStep((prev) => prev + 1);
  const goBack = () => setCurrentStep((prev) => prev - 1);
  const handleDataChange = (newData) => setFormData((prev) => ({ ...prev, ...newData }));

  // ✅ Guard: don’t render form steps until dropdowns are fully loaded
  if (!dropdowns || !dropdowns.sex || !dropdowns.color || !dropdowns.breeds) {
    return <p className="text-center text-gray-500 text-sm">Loading form...</p>;
  }

  return (
    <div className="max-w-5xl mx-auto p-4">
      {currentStep === 1 && (
        <Step1BasicInfo
          formData={formData}
          dropdowns={dropdowns}
          onNext={goNext}
          onChange={handleDataChange}
        />
      )}
      {currentStep === 2 && (
        <Step2Temperament
          formData={formData}
          dropdowns={dropdowns}
          onNext={goNext}
          onBack={goBack}
          onChange={handleDataChange}
        />
      )}
      {currentStep === 3 && (
        <Step3Health
          formData={formData}
          dropdowns={dropdowns}
          onNext={goNext}
          onBack={goBack}
          onChange={handleDataChange}
        />
      )}
      {currentStep === 4 && (
        <Step4Pricing
          formData={formData}
          onNext={goNext}
          onBack={goBack}
          onChange={handleDataChange}
        />
      )}
      {currentStep === 5 && (
        <Step5Finalize
          formData={formData}
          onBack={goBack}
        />
      )}
    </div>
  );
}